import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateWhatsappConsentMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  consented: Types.Scalars['Boolean'];
  uiDefaultArgs: Types.UpsertUiDefaultInput;
}>;


export type UpdateWhatsappConsentMutation = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly whatsappConsent: boolean } | null }, readonly upsertUiDefault: { readonly __typename?: 'UiDefault', readonly id: string, readonly namespace: string, readonly name: string, readonly scope: Types.DefaultScope, readonly value: unknown } };

export type GetUserWhatsappConsentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserWhatsappConsentQuery = { readonly __typename?: 'Query', readonly myUser?: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly whatsappConsent: boolean } | null } | null };


export const UpdateWhatsappConsentDocument = gql`
    mutation UpdateWhatsappConsent($userId: String!, $consented: Boolean!, $uiDefaultArgs: UpsertUiDefaultInput!) {
  updateUser(input: {_id: $userId, person: {whatsappConsent: $consented}}) {
    _id
    person {
      whatsappConsent
    }
  }
  upsertUiDefault(input: $uiDefaultArgs) {
    id
    namespace
    name
    scope
    value
  }
}
    `;
export type UpdateWhatsappConsentMutationFn = Apollo.MutationFunction<UpdateWhatsappConsentMutation, UpdateWhatsappConsentMutationVariables>;

/**
 * __useUpdateWhatsappConsentMutation__
 *
 * To run a mutation, you first call `useUpdateWhatsappConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWhatsappConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWhatsappConsentMutation, { data, loading, error }] = useUpdateWhatsappConsentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      consented: // value for 'consented'
 *      uiDefaultArgs: // value for 'uiDefaultArgs'
 *   },
 * });
 */
export function useUpdateWhatsappConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWhatsappConsentMutation, UpdateWhatsappConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWhatsappConsentMutation, UpdateWhatsappConsentMutationVariables>(UpdateWhatsappConsentDocument, options);
      }
export type UpdateWhatsappConsentMutationHookResult = ReturnType<typeof useUpdateWhatsappConsentMutation>;
export type UpdateWhatsappConsentMutationResult = Apollo.MutationResult<UpdateWhatsappConsentMutation>;
export type UpdateWhatsappConsentMutationOptions = Apollo.BaseMutationOptions<UpdateWhatsappConsentMutation, UpdateWhatsappConsentMutationVariables>;
export const GetUserWhatsappConsentDocument = gql`
    query GetUserWhatsappConsent {
  myUser {
    _id
    person {
      whatsappConsent
    }
  }
}
    `;

/**
 * __useGetUserWhatsappConsentQuery__
 *
 * To run a query within a React component, call `useGetUserWhatsappConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWhatsappConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWhatsappConsentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWhatsappConsentQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWhatsappConsentQuery, GetUserWhatsappConsentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWhatsappConsentQuery, GetUserWhatsappConsentQueryVariables>(GetUserWhatsappConsentDocument, options);
      }
export function useGetUserWhatsappConsentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWhatsappConsentQuery, GetUserWhatsappConsentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWhatsappConsentQuery, GetUserWhatsappConsentQueryVariables>(GetUserWhatsappConsentDocument, options);
        }
export type GetUserWhatsappConsentQueryHookResult = ReturnType<typeof useGetUserWhatsappConsentQuery>;
export type GetUserWhatsappConsentLazyQueryHookResult = ReturnType<typeof useGetUserWhatsappConsentLazyQuery>;
export type GetUserWhatsappConsentQueryResult = Apollo.QueryResult<GetUserWhatsappConsentQuery, GetUserWhatsappConsentQueryVariables>;